<template>
  <DefineTemplate>
    <LineClamp
      class="tw:text-base tw:font-bold tw:text-denim-950"
      :lines="1"
      tag="span"
    >
      {{ mention.source.name }}
      <template #after="{ clamped }">
        <StreemTooltip v-if="clamped">
          {{ mention.source.name }}
        </StreemTooltip>
      </template>
    </LineClamp>
  </DefineTemplate>

  <SyndicationsPopper
    v-if="mention?.syndications?.length && props.stream"
    v-slot="{ toggleOpen }"
    :mention="mention"
    :parent-el-ref="props.mentionCardRef"
    :stream="props.stream"
    @syndication-clicked="syndicationClicked($event)"
  >
    <BaseButton
      new-design
      plain
      @click.stop.prevent="toggleOpen"
    >
      <ReuseTemplate />
      <span>+{{ mention.syndications.length }}</span>
    </BaseButton>
  </SyndicationsPopper>
  <span
    v-else
    class="alternate"
  >
    <ReuseTemplate />
  </span>

  <span class="tw:text-denim-900">
    {{ mention.source.location }}
  </span>

  <span class="softer tw:text-sm">
    <!-- using start_time below as a fallback since timestamp isn't always available and they seem to have the same value -->
    <TimeAgo
      :date="mention.timestamp || mention.start_time"
      :timezone="mention.source.time_zone"
    />
    <span v-if="mention.program_airing">
      · {{ mention.program_airing.name }}
    </span>
  </span>
  <ArchivedContentLabel
    v-if="hasArchivedTvEyesContent(mention)"
    :mention="mention"
  />
</template>

<script setup lang="ts">
import { createReusableTemplate } from "@vueuse/core";
import { computed } from "vue";

import { BaseButton, LineClamp, StreemTooltip } from "shared/components/base";
import TimeAgo from "shared/components/core/various/TimeAgo.vue";
import { SyndicationsPopper } from "shared/components/SyndicationsPopper/index";
import { hasArchivedTvEyesContent } from "shared/services/mention";
import { type Nullable, type Stream } from "shared/types";
import {
  type RadioClip,
  type Syndication,
  type TvCaption,
} from "shared/types/mentions";

import { ArchivedContentLabel } from "./index";

const [DefineTemplate, ReuseTemplate] = createReusableTemplate();

export type BroadcastContentMention = TvCaption | RadioClip;

export interface BroadcastContentMentionCardHeaderProps {
  mention: BroadcastContentMention;
  stream?: Stream;
  mentionCardRef?: Nullable<HTMLElement>;
}

const props = withDefaults(
  defineProps<BroadcastContentMentionCardHeaderProps>(),
  {
    stream: undefined,
    mentionCardRef: null,
  }
);

const emit = defineEmits(["mention-clicked"]);

const mention = computed<BroadcastContentMention>(() => props.mention);

function syndicationClicked(syndication: Syndication) {
  emit("mention-clicked", syndication);
}
</script>
